import { WorkoutSetDimension as l } from "../types/powersync/generated.js";
class V {
  /**
   * Calculate workout summary statistics
   */
  static calculateSummary(e) {
    const { workout: o, setValues: i, exerciseDimensions: a, sets: m, exerciseIds: f } = e, c = new Map(
      a.map((t) => [t.id, t])
    ), p = new Set(
      m.filter((t) => t.completedAt).map((t) => t.id)
    ), h = i.filter(
      (t) => p.has(t.setId)
    ).reduce((t, s) => (t.has(s.setId) || t.set(s.setId, []), t.get(s.setId).push(s), t), /* @__PURE__ */ new Map()), u = Array.from(h.values()).map((t) => {
      const s = t.filter((n) => {
        const r = c.get(n.exerciseDimensionId);
        return (r == null ? void 0 : r.dimension) === l.WEIGHT;
      }).reduce((n, r) => n + r.value, 0), d = t.filter((n) => {
        const r = c.get(n.exerciseDimensionId);
        return (r == null ? void 0 : r.dimension) === l.REPS;
      }).reduce((n, r) => n + r.value, 0);
      return { weight: s, reps: d, volume: s * d };
    }), g = u.reduce((t, s) => t + s.volume, 0), D = u.reduce((t, s) => t + s.reps, 0), S = this.calculateDuration(o), I = f.length;
    return {
      totalVolume: g,
      totalReps: D,
      totalDuration: S,
      exerciseCount: I
    };
  }
  /**
   * Calculate workout duration in minutes
   */
  static calculateDuration(e) {
    if (!e.startedAt || !e.finishedAt)
      return 0;
    const o = new Date(e.startedAt), a = new Date(e.finishedAt).getTime() - o.getTime();
    return Math.round(a / (1e3 * 60));
  }
  /**
   * Format volume for display (handle large numbers)
   */
  static formatVolume(e) {
    return e >= 1e3 ? (e / 1e3).toFixed(1) + "k" : e.toString();
  }
  /**
   * Format duration for display
   */
  static formatDuration(e) {
    if (e >= 60) {
      const o = Math.floor(e / 60), i = e % 60;
      return i === 0 ? `${o}h` : `${o}h ${i}m`;
    }
    return `${e}m`;
  }
}
export {
  V as WorkoutSummaryUtils
};
